import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { translations } from "./translations";

export const LANGS = [
  { code: "en", label: "EN", name: "English" },
  { code: "tr", label: "TR", name: "Türkçe" },
  { code: "fr", label: "FR", name: "Français" },
  { code: "de", label: "DE", name: "Deutsch" },
  { code: "es", label: "ES", name: "Español" },
];

const LangCtx = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("aurevia-lang") || "en");

  useEffect(() => {
    localStorage.setItem("aurevia-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback(
    (key, vars) => {
      const lookup = (dict) => key.split(".").reduce((o, k) => (o ? o[k] : undefined), dict);
      let s = lookup(translations[lang]) ?? lookup(translations.en) ?? key;
      if (vars) Object.entries(vars).forEach(([k, v]) => { s = s.replaceAll(`{${k}}`, v); });
      return s;
    },
    [lang]
  );

  return <LangCtx.Provider value={{ lang, setLang, t }}>{children}</LangCtx.Provider>;
}

export const useLang = () => useContext(LangCtx);
